module.exports = {"TXTWCL_All_N0_Markets":{"id":"TXTWCL_All_N0_Markets","defaultMessage":"Toate opţiunile de pariere pentru {0}"}}